











































import { Component, Prop, Vue } from 'vue-property-decorator'
import AuthContainer from '@/components/auth/AuthContainer.vue'

@Component({
  components: { AuthContainer },
})
export default class AuthDefaultContainer extends Vue {
  @Prop({ default: false, type: Boolean }) private stretch!: string

  @Prop({ default: false, type: Boolean }) private light!: string

  // eslint-disable-next-line class-methods-use-this
  get currentYear(): number {
    return new Date().getFullYear()
  }

  goToCrm(): void {
    window.location.href = '/'
  }

  helpClick(): void {
    this.$router.push('/terms')
  }
}
